import { type ThemeConfig } from '#imports'
import { defu } from 'defu'

export const useThemeConfig = () => {
  // Used as fallback
  const appConfig = useAppConfig()

  // Initially, set the theme config to the tenant theme config
  const { themeConfig: tenantThemeConfig } = useTenantConfig()

  // Prefer the tenant theme config over the app config, but use the app config as fallback
  function mergeWithDefaults(config: Partial<ThemeConfig>) {
    return defu(config, appConfig.theme) as ThemeConfig
  }

  function setThemeConfig(config: Partial<ThemeConfig>) {
    themeConfig.value = mergeWithDefaults(config)
  }

  const themeConfig = useState<ThemeConfig>('themeConfig', () => mergeWithDefaults(tenantThemeConfig))

  return { themeConfig, setThemeConfig }
}
